/**
 * @generated SignedSource<<6d94816cc84e72c24555bf571f81bc7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UrlMetaData_queryFragment$data = {
  readonly urlMetaData: {
    readonly canonicalUrl: string;
    readonly description: string;
    readonly facebookImageUrl: string;
    readonly openGraphImageAltText: string;
    readonly openGraphImageDimensions: {
      readonly height: number;
      readonly width: number;
    };
    readonly title: string;
    readonly twitterImageUrl: string;
    readonly updatedAt: ContraAPIScalars.DateTime | null;
  };
  readonly " $fragmentType": "UrlMetaData_queryFragment";
};
export type UrlMetaData_queryFragment$key = {
  readonly " $data"?: UrlMetaData_queryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"UrlMetaData_queryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "url"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "UrlMetaData_queryFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "url",
          "variableName": "url"
        }
      ],
      "concreteType": "UrlMetaData",
      "kind": "LinkedField",
      "name": "urlMetaData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "facebookImageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "twitterImageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canonicalUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "openGraphImageAltText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UrlMetadataImageDimensions",
          "kind": "LinkedField",
          "name": "openGraphImageDimensions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "da00d71c8f3db20a368732963e092479";

export default node;
